import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-who-we-are-container" }
const _hoisted_2 = { class: "home-who-we-are-note animate__animated animate__slideInRight" }
const _hoisted_3 = { class: "home-who-we-are-note-title" }
const _hoisted_4 = { class: "home-who-we-are-note-description" }
const _hoisted_5 = { class: "home-who-we-are-note-middle-main" }
const _hoisted_6 = { class: "home-who-we-are-note-description" }
const _hoisted_7 = { class: "home-who-we-are-note-description" }
const _hoisted_8 = { class: "home-who-we-are-note-description" }
const _hoisted_9 = { class: "home-who-we-are-note-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "home-who-we-are-image" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("home.who-we-are.title")), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("home.who-we-are.description-1")), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.who-we-are.subtitle")), 1)
      ]),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("home.who-we-are.description-2")), 1),
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("home.who-we-are.description-3")), 1),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("home.who-we-are.description-4")), 1),
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("home.who-we-are.description-5")), 1)
    ])
  ]))
}